import React, { Component } from 'react';
import './_preloader.scss'
import ShimmerLoader from './ShimmerLoader';

class Preloader extends Component {
    PreLoaderElement() {
        return new Promise(resolve => setTimeout(resolve, 5000))
    }

    componentDidMount() {
        this.PreLoaderElement().then(() => {
            const preloaderEle = document.getElementById('preloader')
            if (preloaderEle) {
                // fade out
                preloaderEle.classList.add('available')
                setTimeout(() => {
                    // remove from DOM
                    preloaderEle.outerHTML = ''
                }, 1000)
            }
        })
    }

    render() {
        return (
            <div className="preloader" id="preloader">
                <ShimmerLoader />
            </div>
        );
    }
}

export default Preloader;